import React from "react";
import { FlexRow } from "./styledComponents";

function FilterTabs({ currentTab, onTabChange, categoryTotals }) {
  const tabLabels = {
    coin: "Coins",
    token: "Tokens",
    "stable-token": "Stablecoins",
  };

  const getBalance = (tab) => {
    if (!categoryTotals) return "";
    const balanceMap = {
      coin: categoryTotals.coins || 0,
      token: categoryTotals.tokens || 0,
      "stable-token": categoryTotals.stableTokens || 0,
    };
    const balance = balanceMap[tab];
    return typeof balance === "number" 
      ? ` $ ${balance.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      : "";
  };

  return (
    <FlexRow gap={8} style={{ marginTop: "12px", marginBottom: "12px" }}>
      {["coin", "token", "stable-token"].map((t) => (
        <button
          key={t}
          onClick={() => onTabChange(t)}
          style={{
            padding: "8px 16px",
            borderRadius: "6px",
            border: "none",
            background: currentTab === t 
              ? "linear-gradient(90deg, #00f7d2, #5ce9ff)" 
              : "#020617",
            color: currentTab === t ? "#001018" : "#e5e7eb",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: currentTab === t ? 600 : 500,
            transition: "all 0.2s ease",
            flex: 1,
            whiteSpace: "nowrap",
          }}
        >
          {tabLabels[t]} . {getBalance(t)}
        </button>
      ))}
    </FlexRow>
  );
}

export default FilterTabs;

